import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type {
  FreemiumBannerMobileDefinition,
  FreemiumBannerMobilePlatformProps,
  FreemiumBannerMobileProps,
} from '../FreemiumBannerMobile.types';
import { props as viewerPropsMapper } from './FreemiumBannerMobile.mapper';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import translationKeys from '../../FreemiumBannerDesktop/viewer/constants';
import { TranslationFallbacks, TranslationKeys } from './constants';
import { freemiumBannerExperiments } from '../../common/constants';
import concatQueryParamsToUrl from '../../common/concatQueryParamsToUrl';

export const props = composeMapper<
  FreemiumBannerMobilePlatformProps,
  FreemiumBannerMobileDefinition
>()(
  viewerPropsMapper,
  { add: ['experiments', 'translate', 'metaSiteId'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);

    const translations = (viewerProps as FreemiumBannerMobileProps)
      .translations;

    const { experiments, metaSiteId, translate } = deps;

    const shouldShowNewBanner = isExperimentOpen(
      experiments,
      freemiumBannerExperiments.newBannerMobile,
    );

    const hrefLogoNewPreview =
      translate(
        translationKeys.NAMESPACE,
        TranslationKeys.hrefLogoNewPreview,
      ) || TranslationFallbacks.HrefLogoNewPreview;

    const hrefLogoNewWithQueryParams = concatQueryParamsToUrl(
      hrefLogoNewPreview,
      { orig_msid: metaSiteId, adsVersion: 'banner_2024_preview' },
    );

    const href = shouldShowNewBanner
      ? hrefLogoNewWithQueryParams
      : `https://apps.wix.com/place-invites/join-lp/${metaSiteId}?ref=free_banner`;

    return {
      ...viewerProps,
      shouldReportBi: false,
      href,
      translations: {
        ...translations,
        ...(shouldShowNewBanner && {
          genericAppBannerText:
            translate(
              translationKeys.NAMESPACE,
              TranslationKeys.genericAppNewBannerPreview,
            ) || TranslationFallbacks.genericAppNewBannerPreview,
        }),
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
